// =============================================================================
// SimSense Platform — Units Hook
// =============================================================================

import { useAuthStore } from "../state/authStore";
import { units, UnitSystem } from "../utils/unitConversion";

export function useUnits() {
  const user = useAuthStore(state => state.user);
  const system: UnitSystem = user?.preferences?.units || "standard";

  return {
    system,
    formatSpeed: (ms: number) => units.speed(ms, system),
    formatTemp: (c: number) => units.temp(c, system),
    formatPressure: (kpa: number) => units.pressure(kpa, system),
    formatWeight: (newtons: number) => units.weight(newtons, system),
    formatFuel: (liters: number) => system === "metric" ? `${liters.toFixed(2)} L` : `${(liters * 0.264172).toFixed(2)} gal`,
    formatDelta: units.delta
  };
}
